export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10443.fe683e6f.jpg";